// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"6710": "e8383776","7916": "6c873022","977": "62461f92",}[chunkId] + ".css"
}